interface PopupWindowWithActivation extends Window {
  restore?: () => void
  show?: () => void
  moveTop?: () => void
}

const focusPopupWindow = (popupWindow: PopupWindowWithActivation) => {
  try {
    popupWindow.show?.()
  } catch {
    // 브라우저 환경에서는 show API가 없다.
  }

  try {
    popupWindow.moveTop?.()
  } catch {
    // 브라우저 환경에서는 moveTop API가 없다.
  }

  try {
    popupWindow.focus()
  } catch {
    // 이미 닫히는 중인 창은 포커스할 수 없다.
  }
}

export const bringDetachedPopupToFront = async (popupWindow: Window, title: string): Promise<boolean> => {
  if (popupWindow.closed) return false

  const popupWindowWithActivation = popupWindow as PopupWindowWithActivation
  const isImagePreview = popupWindow.name?.startsWith("SigmaPatientImagePreviewDetached") ?? false

  try {
    let restored = false
    if (isImagePreview) {
      const windows = await window.electronAPI?.getDockWindows?.()
      const targetWindow = windows?.find(entry => entry.frameName === popupWindow.name)
      if (targetWindow) restored = (await window.electronAPI?.focusDockWindow?.(targetWindow.id)) ?? false
    } else {
      restored = (await window.electronAPI?.restoreWindowByTitle?.(title)) ?? false
    }
    if (restored) {
      focusPopupWindow(popupWindowWithActivation)
      return true
    }
  } catch {
    // IPC 복원 실패 시 popup 자체 복원으로 이어간다.
  }

  try {
    const restored = await popupWindow.electronAPI?.restore?.()
    if (restored) {
      focusPopupWindow(popupWindowWithActivation)
      return true
    }
  } catch {
    // preload API가 없는 웹 환경에서는 Window API로 이어간다.
  }

  try {
    popupWindowWithActivation.restore?.()
  } catch {
    // 브라우저 환경에서는 restore API가 없다.
  }

  focusPopupWindow(popupWindowWithActivation)
  return !popupWindow.closed
}
